// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.datepicker {\n  width: 230px;\n}\n.datepicker .dropdown.is-bottom-left .dropdown-menu {\n    right: 0;\n    left: auto;\n}\n.datepicker .dropdown.is-top-left .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    right: 0;\n    left: auto;\n}\n.datepicker .dropdown.is-top-right .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
